import React, { useState, useMemo } from 'react';
import './Tours.css';

const WA = '919445879508';

/* ══════════════════════════════════════════════════════════════
   COMPLETE PACKAGE DATABASE — Maggi Cabs
   Tamil Nadu 40+ | Kerala 30+ | 100+ Tour Packages
   ══════════════════════════════════════════════════════════════ */

const ALL_PACKAGES = [

  /* ══════════════════════════════
     TAMIL NADU — HILL STATIONS
     ══════════════════════════════ */
  { id:1, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kodaikanal', type:'Honeymoon', icon:'💑', tag:'Most Popular',
    title:'Kodaikanal Honeymoon Special',
    desc:"Romantic sunrise at Coaker's Walk, boat ride on the star-shaped Kodai Lake, misty Pine Forest walk and Silver Cascade waterfall.",
    includes:["Coaker's Walk Sunrise",'Kodai Lake Boating','Silver Cascade','Pine Forest','Pillar Rocks','Bear Shola Falls'],
    duration:'2 Days / 1 Night', vehicle:'4-Seater Car', highlight:'Flower decoration on request',
    img:'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=600&q=80' },

  { id:2, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kodaikanal', type:'Family', icon:'👨‍👩‍👧‍👦',
    title:'Kodaikanal Family Package',
    desc:"Kid-friendly Kodaikanal covering Bryant Park, Guna Cave, Silver Cascade and Kodai Lake with horse riding and boating.",
    includes:['Kodai Lake','Bryant Park','Silver Cascade','Fairy Falls','Guna Cave','Valley View'],
    duration:'Full Day', vehicle:'7-Seater SUV', highlight:'Child-friendly itinerary',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  { id:3, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kodaikanal', type:'Group', icon:'🎒',
    title:'Kodaikanal Group Tour',
    desc:"Full-day group sightseeing covering all major viewpoints, waterfalls and the scenic Pine Forest.",
    includes:["Coaker's Walk",'Pillar Rocks','Guna Cave','Silver Cascade','Pine Forest','Kodai Lake',"Dolphin's Nose",'Bear Shola Falls'],
    duration:'Full Day', vehicle:'12 or 25 Seater', highlight:'8+ spots — group discount',
    img:'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=80' },

  { id:4, state:'Tamil Nadu', cat:'Hill Stations', dest:'Ooty', type:'Honeymoon', icon:'💑',
    title:'Ooty Honeymoon Package',
    desc:"Romance in the Nilgiris — Botanical Garden, Ooty Lake, Doddabetta Peak, Nilgiri toy train ride and rose gardens.",
    includes:['Ooty Botanical Garden','Doddabetta Peak','Nilgiri Toy Train Ride','Ooty Lake Boating','Rose Garden','Pykara Lake'],
    duration:'2 Days / 1 Night', vehicle:'4-Seater Car', highlight:'Toy train couple tickets',
    img:'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=600&q=80' },

  { id:5, state:'Tamil Nadu', cat:'Hill Stations', dest:'Ooty', type:'Family', icon:'👨‍👩‍👧‍👦',
    title:'Ooty Family Tour',
    desc:"The Queen of Hills for families — Botanical Garden, Wax World, Ooty Lake boating, Pykara waterfall and toy train.",
    includes:['Ooty Botanical Garden','Pykara Falls','Ooty Lake','Wax World Museum','Tea Factory','Thread Garden'],
    duration:'Full Day / 2 Days', vehicle:'7-Seater SUV', highlight:'Toy train experience',
    img:'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=600&q=80' },

  { id:6, state:'Tamil Nadu', cat:'Hill Stations', dest:'Coonoor', type:'Sightseeing', icon:'🌿',
    title:'Coonoor Day Trip',
    desc:"The quieter, greener sibling of Ooty — Sim's Park, Dolphin's Nose viewpoint, Lamb's Rock and rolling tea estates.",
    includes:["Sim's Park","Lamb's Rock","Dolphin's Nose",'Tea Estate Walk','Droog Fort','High Field Tea Factory'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Less crowded than Ooty',
    img:'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=600&q=80' },

  { id:7, state:'Tamil Nadu', cat:'Hill Stations', dest:'Yercaud', type:'Sightseeing', icon:'🏔️',
    title:'Yercaud Hill Station Tour',
    desc:"The Jewel of the South — Shevaroy Hills covered with coffee and spice plantations, Yercaud Lake and Anna Park.",
    includes:['Yercaud Lake','Anna Park','Pagoda Point','Servarayan Temple',"Lady's Seat",'Killiyur Falls'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Coffee estate tour included',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:8, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kotagiri', type:'Sightseeing', icon:'☕',
    title:'Kotagiri Tea Estate Tour',
    desc:"The oldest hill station in the Nilgiris — tea factory tours, Kodanad viewpoint, Catherine Falls and Rangaswamy Peak.",
    includes:['Kodanad Viewpoint','Catherine Falls','Rangaswamy Peak','Tea Factory Tour','Elk Falls','Village Walk'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Oldest Nilgiri hill station',
    img:'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=600&q=80' },

  { id:9, state:'Tamil Nadu', cat:'Hill Stations', dest:'Valparai', type:'Nature', icon:'🐘',
    title:'Valparai Wildlife & Tea Tour',
    desc:"A hidden gem in the Anamalai Hills — dense tea estates, elephants crossing roads and shola forests.",
    includes:['Monkey Falls','Balaji Temple','Grass Hills','Tea Estate Drive','Elephant Spotting','Sholayar Dam'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Wild elephant sightings on road',
    img:'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=600&q=80' },

  { id:10, state:'Tamil Nadu', cat:'Hill Stations', dest:'Yelagiri', type:'Sightseeing', icon:'🪁',
    title:'Yelagiri Hills Package',
    desc:"A peaceful hill station near Vellore — Punganur Lake, Swamimalai Hills and adventure sports in lush green surroundings.",
    includes:['Punganur Lake','Swamimalai Hill','Nilavoor Lake','Nature Walk','Boat Ride','Yelagiri Peak View'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Adventure sports available',
    img:'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=80' },

  { id:11, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kolli Hills', type:'Adventure', icon:'⛰️',
    title:'Kolli Hills Adventure Tour',
    desc:"72 hairpin bends to the top! Arapaleeswarar Temple, Agaya Gangai waterfall and untouched tribal villages.",
    includes:['72 Hairpin Bends Drive','Arapaleeswarar Temple','Agaya Gangai Falls','Tribal Village Visit','Herbal Garden','Selur Arch Dam'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'72 hairpin bend drive',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  /* ══════════════════════════════
     TAMIL NADU — TEMPLES / SPIRITUAL
     ══════════════════════════════ */
  { id:12, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Madurai', type:'Pilgrimage', icon:'🛕', tag:'Popular',
    title:'Madurai Meenakshi Temple Tour',
    desc:"City of Temples — the magnificent Meenakshi Amman Temple, Thirumalai Nayakkar Palace and vibrant bazaars.",
    includes:['Meenakshi Amman Temple','Thirumalai Nayakkar Palace','Koodal Azhagar Temple','Gandhi Memorial Museum','Teppakulam Lake','Jigarthanda Food Stop'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Night aarti darshan available',
    img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&q=80' },

  { id:13, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Rameswaram', type:'Pilgrimage', icon:'🌊',
    title:'Rameswaram Sacred Pilgrimage',
    desc:"One of India's holiest shrines — Ramanathaswamy Temple with 1,212 corridor pillars and the sacred Agni Theertham.",
    includes:['Ramanathaswamy Temple','Agni Theertham Bath','Dhanushkodi','Pamban Bridge','22 Theertham Circuit','Ariyaman Beach'],
    duration:'2 Days / 1 Night', vehicle:'Any Vehicle', highlight:'22 holy theertham baths',
    img:'https://images.unsplash.com/photo-1567157577867-05ccb1388e66?w=600&q=80' },

  { id:14, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Chidambaram', type:'Pilgrimage', icon:'🕉️',
    title:'Chidambaram Nataraja Temple Tour',
    desc:"The cosmic dance of Shiva — Thillai Nataraja Temple, one of the Pancha Bhuta Sthalams representing space (Akash).",
    includes:['Thillai Nataraja Temple','Shivaganga Tank','Periyanayaki Amman','Nritya Sabhai','Thiruvengadu Temple','Pichavaram Mangroves'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Pancha Bhuta Sthalams — Akash',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  { id:15, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Kanchipuram', type:'Pilgrimage', icon:'🛕',
    title:'Kanchipuram Temple City Tour',
    desc:"City of Thousand Temples and Silk Sarees — Kailasanathar, Varadharaja Perumal and Ekambareswarar temples.",
    includes:['Kailasanathar Temple','Varadharaja Perumal Temple','Ekambareswarar Temple','Kamakshi Amman','Silk Weaving Visit','Vedanthangal Bird Sanctuary'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'1,000 temples — silk city',
    img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&q=80' },

  { id:16, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Tiruchirappalli', type:'Pilgrimage', icon:'🏰',
    title:'Trichy Rock Fort & Srirangam Tour',
    desc:"Rock Fort Temple towering 83m high + the world's largest functioning Hindu temple at Srirangam island.",
    includes:['Rock Fort Uchi Pillayar','Sri Ranganathaswamy Temple','Jambukeswarar Temple','Cauvery River','Lourdes Church','Anna Museum'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'World\'s largest temple complex',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:17, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Palani', type:'Pilgrimage', icon:'🛕',
    title:'Palani Murugan Temple Tour',
    desc:"Arulmigu Dhandayuthapani Swamy atop Sivagiri Hill — one of the six abodes of Lord Murugan.",
    includes:['Palani Murugan Temple','Cable Car Ride','Theertham Bath','Panchamirtham Prasad','Thiruparamkunram Temple','Govindhasamy Temple'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Cable car to summit included',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  { id:18, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Tiruvannamalai', type:'Pilgrimage', icon:'🔥',
    title:'Tiruvannamalai Arunachala Tour',
    desc:"The sacred fire hill — Annamalaiyar Temple, girivalam path around Arunachala and Ramana Maharshi Ashram.",
    includes:['Annamalaiyar Temple','Arunachala Girivalam Path','Ramana Maharshi Ashram','Sri Seshadri Swamigal Ashram','Adi Annamalai Temple','Sunrise at Hill Top'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Sacred 14-km girivalam circuit',
    img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&q=80' },

  { id:19, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Srirangam', type:'Pilgrimage', icon:'🛕',
    title:'Srirangam + Thanjavur Combo',
    desc:"Two UNESCO-level temple towns — Sri Ranganathaswamy Temple (world's largest) + Brihadeeswarar Temple.",
    includes:['Sri Ranganathaswamy Temple','Brihadeeswarar Temple','Rock Fort','Saraswathi Mahal Library','Thanjavur Palace','Art Gallery'],
    duration:'Full Day / Overnight', vehicle:'Any Vehicle', highlight:'2 UNESCO sites in 1 day',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  /* ══════════════════════════════
     TAMIL NADU — HERITAGE / CULTURAL
     ══════════════════════════════ */
  { id:20, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Thanjavur', type:'Heritage', icon:'🏛️',
    title:'Thanjavur Chola Heritage Tour',
    desc:"The Chola capital — Brihadeeswarar Temple (UNESCO), Thanjavur Palace, Saraswathi Mahal Library and classical art galleries.",
    includes:['Brihadeeswarar Temple','Thanjavur Palace & Museum','Saraswathi Mahal Library','Art Gallery','Sangeetha Mahal','Schwartz Church'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'UNESCO World Heritage Temple',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:21, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Chettinad', type:'Heritage', icon:'🏠',
    title:'Chettinad Heritage & Food Tour',
    desc:"Grand Nattukotai Chettiar mansions, antique collections and the world-famous Chettinad cuisine experience.",
    includes:['Chettinad Palace Visit','Kanadukathan Heritage Walk','Local Cuisine Experience','Antique Shops','Athangudi Tile Factory','Karaikudi Town'],
    duration:'Full Day', vehicle:'7 or 12 Seater', highlight:'Famous Chettinad lunch included',
    img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&q=80' },

  { id:22, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Mahabalipuram', type:'Heritage', icon:'🗿',
    title:'Mahabalipuram Shore Temple Tour',
    desc:"Pallava dynasty rock-cut temples and sculptures on the Bay of Bengal coast — UNESCO World Heritage Site.",
    includes:['Shore Temple','Five Rathas','Arjuna\'s Penance','Krishna\'s Butter Ball','Tiger Cave','Mahabalipuram Beach'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'UNESCO Pallava rock temples',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:23, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Gangaikonda Cholapuram', type:'Heritage', icon:'🏛️',
    title:'Gangaikonda Cholapuram Tour',
    desc:"The lost Chola capital — a lesser-known but magnificent Brihadeeswarar temple built by Rajendra Chola.",
    includes:['Gangaikonda Cholapuram Temple','Chola Museum','Kumbakonam Temple Circuit','Airavatesvara Temple Darasuram','Swamimalai Bronze Art','Cauvery River Ghat'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Forgotten Chola capital — less crowds',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  { id:24, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Darasuram', type:'Heritage', icon:'🏛️',
    title:'Darasuram Airavatesvara Tour',
    desc:"The third of the Great Living Chola Temples — Airavatesvara Temple at Darasuram with intricate stone carvings.",
    includes:['Airavatesvara Temple Darasuram','Kumbakonam Temples','Sarangapani Temple','Brahadeeswarar Thanjavur','Mahamaham Tank','Pottery Village'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'3rd UNESCO Great Chola Temple',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  /* ══════════════════════════════
     TAMIL NADU — BEACHES / COASTAL
     ══════════════════════════════ */
  { id:25, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Kanyakumari', type:'Honeymoon', icon:'🌅', tag:'Romantic',
    title:'Kanyakumari Honeymoon Tour',
    desc:"Where three seas meet at India's southern tip — sunrise/sunset views, Vivekananda Rock and pristine beaches.",
    includes:['Vivekananda Rock Memorial','Thiruvalluvar Statue','Kumari Amman Temple','Sunrise & Sunset Views','Padmanabhapuram Palace','Thirparappu Falls'],
    duration:'2 Days / 1 Night', vehicle:'4-Seater Car', highlight:'Sunrise boat to Vivekananda Rock',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  { id:26, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Velankanni', type:'Pilgrimage', icon:'⛪',
    title:'Velankanni Basilica Pilgrimage',
    desc:"Our Lady of Good Health Basilica — the Lourdes of the East on the Coromandel Coast.",
    includes:['Velankanni Basilica','Miraculous Medal Shrine','Museum of Miracles','Lighthouse Beach','Beach Darshan','Nagapattinam Temples'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Lourdes of the East',
    img:'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=600&q=80' },

  { id:27, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Nagapattinam', type:'Heritage', icon:'⚓',
    title:'Nagapattinam Coastal Heritage Tour',
    desc:"Historic port town with Dutch heritage, ancient temples and the serene Coromandel coast beaches.",
    includes:['Kayarohana Swami Temple','Sikkal Singaravelan Temple','Dutch Bungalow','Tsunami Memorial Park','Nagore Dargah','Velankanni Basilica'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Dutch colonial heritage',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:28, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Poompuhar', type:'Heritage', icon:'🌊',
    title:'Poompuhar Ancient Port Tour',
    desc:"The ancient Chola port city of Kaveripattinam — Silappathikaram monument, beach and the mouth of River Kaveri.",
    includes:['Poompuhar Beach','Silappathikaram Art Gallery','Kaveri River Mouth','Ancient Port Site','Marine Museum','Tranquebar Dutch Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Ancient Chola maritime history',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  /* ══════════════════════════════
     TAMIL NADU — NATURE / WILDLIFE
     ══════════════════════════════ */
  { id:29, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Mudumalai National Park', type:'Wildlife', icon:'🐯',
    title:'Mudumalai Wildlife Safari',
    desc:"One of the finest wildlife corridors in South India — spot elephants, tigers, leopards and gaur in their natural habitat.",
    includes:['Jeep Safari (Forest Dept)','Elephant Camp Visit','Moyar River View','Ooty Combine Option','Bird Watching Trail','Theppakadu Elephant Camp'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Tiger Reserve — Big 5 spotted',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:30, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Anamalai Tiger Reserve', type:'Wildlife', icon:'🌿',
    title:'Anamalai Tiger Reserve Tour',
    desc:"Indira Gandhi Wildlife Sanctuary — one of the richest biodiversity zones with elephants, lions and over 300 bird species.",
    includes:['Topslip Safari','Elephant Bathing Point','Amaravathi Dam','Sethumadai Village','Indira Gandhi Statue','Pollachi Coconut Farms'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Lion-tailed Macaque spotting',
    img:'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=600&q=80' },

  { id:31, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Hogenakkal Falls', type:'Nature', icon:'💧',
    title:'Hogenakkal Falls Day Trip',
    desc:"The Niagara of India — spectacular Kaveri waterfalls with coracle boat rides through the gorge.",
    includes:['Hogenakkal Waterfall View','Coracle Boat Ride','Fish Massage (Optional)','Marikottayam Island','Bathing Ghat','Pennagaram Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Coracle boat in gorge',
    img:'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=600&q=80' },

  { id:32, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Courtallam', type:'Nature', icon:'🌊',
    title:'Courtallam Waterfalls Tour',
    desc:"The Spa of South India — 9 waterfalls with medicinal herbal properties. Perfect for summer cooling.",
    includes:['Main Falls','Five Falls','Old Courtallam Falls','Shenbagadevi Falls','Pechiamman Temple','Tenkasi Kasi Viswanathar Temple'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'9 medicinal waterfalls',
    img:'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=600&q=80' },

  /* ══════════════════════════════
     TAMIL NADU — OTHER DESTINATIONS
     ══════════════════════════════ */
  { id:33, state:'Tamil Nadu', cat:'Other Destinations', dest:'Dhanushkodi', type:'Heritage', icon:'🏚️',
    title:'Dhanushkodi Ghost Town Tour',
    desc:"The abandoned town at the tip of Pamban Island — destroyed by the 1964 cyclone, now a haunting and beautiful landscape.",
    includes:['Dhanushkodi Ghost Town','Arichal Munai Tip','Bay of Bengal & Indian Ocean Confluence','Old Church Ruins','Pamban Bridge View','Rameswaram Temple'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Land\'s end — two seas meet',
    img:'https://images.unsplash.com/photo-1567157577867-05ccb1388e66?w=600&q=80' },

  { id:34, state:'Tamil Nadu', cat:'Other Destinations', dest:'Kumbakonam', type:'Pilgrimage', icon:'🛕',
    title:'Kumbakonam Temple Circuit',
    desc:"The Temple Town of Tamil Nadu — 12 major temples, Mahamaham sacred tank and classical Chola-era art.",
    includes:['Sarangapani Temple','Kumbheswarar Temple','Mahamaham Tank','Nageshwarar Temple','Adi Kumbeswarar Temple','Darasuram Airavatesvara'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'12 major temples in one town',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  { id:35, state:'Tamil Nadu', cat:'Other Destinations', dest:'Tirunelveli', type:'Sightseeing', icon:'🌾',
    title:'Tirunelveli & Courtallam Tour',
    desc:"Nellai's Nellaiappar Temple, the famous Iruttu Kadai Halwa and Courtallam waterfalls combo.",
    includes:['Nellaiappar Temple','Krishnapuram Palace','Courtallam Falls','Manimuthar Dam','Papanasam Dam','Iruttu Kadai Halwa'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Famous Tirunelveli Halwa tasting',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:36, state:'Tamil Nadu', cat:'Other Destinations', dest:'Srivilliputhur', type:'Pilgrimage', icon:'🛕',
    title:'Srivilliputhur Andal Temple Tour',
    desc:"Temple of Andal — the only temple whose gopuram features on the Tamil Nadu government emblem.",
    includes:['Andal Temple Srivilliputhur','Vadapatrasayi Temple','Rajapalayam Vijayarama Raja Temple','Sivakasi Fireworks Factory','Ayyanar Kovil','Sattur Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Emblem of Tamil Nadu',
    img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&q=80' },

  { id:37, state:'Tamil Nadu', cat:'Other Destinations', dest:'Ramanathapuram', type:'Heritage', icon:'🏰',
    title:'Ramanathapuram Setupati Heritage',
    desc:"The kingdom of the Setupati kings — Ramnad Palace, Rameswaram proximity and the pearl fishing town of Tuticorin.",
    includes:['Ramnad Palace & Museum','Sethupathy Fort','Erwadi Dargah','Devipattinam Navagraha Beach','Pamban Bridge','Rameswaram'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Setupati palace & heritage',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:38, state:'Tamil Nadu', cat:'Other Destinations', dest:'Thoothukudi', type:'Coastal', icon:'🐚',
    title:'Thoothukudi Pearl City Tour',
    desc:"The Pearl City — Hare Island, Threspuram Beach, Gulf of Mannar Marine National Park snorkelling.",
    includes:['Hare Island Beach','Our Lady of Snows Basilica','Gulf of Mannar Marine Park','Tiruchendur Murugan Temple','Kayalpatnam','Pearl Industry Visit'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Gulf of Mannar coral reefs',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  { id:39, state:'Tamil Nadu', cat:'Other Destinations', dest:'Sivakasi', type:'Industry', icon:'🎆',
    title:'Sivakasi Fireworks Factory Tour',
    desc:"The Fireworks Capital of India — safe guided tour of fireworks and match factories, plus Kalidass Nagar.",
    includes:['Fireworks Factory Tour (Safe)','Match Factory Visit','Arulmigu Durga Devi Temple','Srivilliputhur Andal Temple','Rajapalayam Tour','Shopping for Crackers'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:"India's fireworks capital",
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:75, state:'Tamil Nadu', cat:'Other Destinations', dest:'Salem', type:'Sightseeing', icon:'🏙️',
    title:'Salem City & Yercaud Hills Tour',
    desc:"Steel City of Tamil Nadu — Yercaud hill station nearby, Sugavaneswarar Temple, Kottai and beautiful rose garden.",
    includes:['Yercaud Hill Station','Sugavaneswarar Temple','Kottai (Salem Fort)','Mettur Dam','Kiliyur Falls','Rose Garden Yercaud'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Mettur Dam — largest in Tamil Nadu',
    img:'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=80' },

  { id:76, state:'Tamil Nadu', cat:'Other Destinations', dest:'Erode', type:'Heritage', icon:'🏺',
    title:'Erode Textile & Temple Tour',
    desc:"Turmeric City and Textile Hub — Bhavani Sangameshwarar Temple at the Kaveri–Bhavani confluence, Kodumudi Murugan Temple.",
    includes:['Bhavani Sangameshwarar Temple','Kodumudi Murugan Temple','Erode Textile Market','Kaveri River Sangam','Gobichettipalayam Sathyamangalam','Periyar Statue'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Kaveri–Bhavani sacred confluence',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:77, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Chennai', type:'Heritage', icon:'🏙️', tag:'New',
    title:'Chennai Heritage & Marina Tour',
    desc:"Tamil Nadu's capital — the world's second longest beach Marina, Kapaleeshwarar Temple, Fort St. George and vibrant food culture.",
    includes:['Marina Beach','Kapaleeshwarar Temple','Fort St. George Museum','San Thome Basilica','Valluvar Kottam','Guindy National Park'],
    duration:'Full Day / 2 Days', vehicle:'Any Vehicle', highlight:"World's 2nd longest beach",
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:40, state:'Tamil Nadu', cat:'Other Destinations', dest:'Coimbatore', type:'Spiritual', icon:'🙏',
    title:'Coimbatore Isha Yoga Tour',
    desc:"Isha Yoga Centre, Vellingiri Hills trek, Adiyogi Statue and the vibrant textile city.",
    includes:['Isha Yoga Centre','Adiyogi Shiva Statue','Vellingiri Hills (Dhyanalinga)','Marudamalai Murugan Temple','VOC Park','Kovai Kutralam Falls'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'108-ft Adiyogi Shiva statue',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  /* ══════════════════════════════
     KERALA — HILL STATIONS
     ══════════════════════════════ */
  { id:41, state:'Kerala', cat:'Hill Stations', dest:'Munnar', type:'Honeymoon', icon:'💑', tag:'New',
    title:'Munnar Honeymoon Package',
    desc:"Misty tea valleys, waterfalls and the most romantic hill views in South India — Munnar is magical for newlyweds.",
    includes:['Mattupetty Dam Boating','Eravikulam National Park','Tea Museum','Top Station','Echo Point','Attukal Waterfalls'],
    duration:'2–3 Days', vehicle:'4-Seater Car', highlight:'Nilgiri Tahr spotting',
    img:'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=600&q=80' },

  { id:42, state:'Kerala', cat:'Hill Stations', dest:'Munnar', type:'Family', icon:'👨‍👩‍👧‍👦',
    title:'Munnar Family Hill Tour',
    desc:"Endless tea estates, elephant encounters and cool mountain air — perfect Kerala family escape.",
    includes:['Tea Plantation Walk','Mattupetty Dam','Kundala Lake','Eravikulam Park','Chinnar Wildlife Sanctuary','Pampadum Shola'],
    duration:'2 Days', vehicle:'7-Seater SUV', highlight:'Tea estate walking tour',
    img:'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=600&q=80' },

  { id:43, state:'Kerala', cat:'Hill Stations', dest:'Wayanad', type:'Nature', icon:'🌿',
    title:'Wayanad Jungle & Heritage Tour',
    desc:"Edakkal Caves, Banasura Sagar Dam, Chembra Peak and tribal villages in the lush Wayanad forests.",
    includes:['Edakkal Caves','Banasura Sagar Dam','Soochipara Falls','Chembra Peak Trek','Pookode Lake','Muthanga Wildlife Sanctuary'],
    duration:'2 Days', vehicle:'4 or 7 Seater', highlight:'4,000-year-old cave paintings',
    img:'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=600&q=80' },

  { id:44, state:'Kerala', cat:'Hill Stations', dest:'Vagamon', type:'Honeymoon', icon:'💑',
    title:'Vagamon Meadows Honeymoon',
    desc:"The Meadows of Kerala — rolling green hills, pine forests and strawberry farms. Perfect hidden romantic getaway.",
    includes:['Vagamon Meadows','Kurisumala Ashram','Pine Forest','Thangalpara Viewpoint','Strawberry Farm','Paragliding Spot'],
    duration:'2 Days', vehicle:'4-Seater Car', highlight:'Hidden romantic hill retreat',
    img:'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=600&q=80' },

  { id:45, state:'Kerala', cat:'Hill Stations', dest:'Ponmudi', type:'Nature', icon:'🦋',
    title:'Ponmudi Hills & Valley Tour',
    desc:"Kerala's mini-Ooty near Thiruvananthapuram — 22 hairpin bends, Peppara Dam and the Golden Valley.",
    includes:['Ponmudi Peak','Golden Valley View','22 Hairpin Drive','Peppara Wildlife Sanctuary','Kallar River','Deer Spotting'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'22 hairpin bends drive',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:46, state:'Kerala', cat:'Hill Stations', dest:'Idukki', type:'Nature', icon:'🏞️',
    title:'Idukki Arch Dam & Jungle Tour',
    desc:"Asia's first arch dam set in a stunning gorge — Idukki Wildlife Sanctuary, Thattekad Bird Sanctuary.",
    includes:['Idukki Arch Dam','Idukki Wildlife Sanctuary','Malankara Reservoir','Ramakkalmedu Wind Farm','Cheruthoni Dam','Thattekad Bird Sanctuary'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Asia\'s first arch dam',
    img:'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=600&q=80' },

  { id:47, state:'Kerala', cat:'Hill Stations', dest:'Nelliyampathy', type:'Nature', icon:'☕',
    title:'Nelliyampathy Coffee Hills Tour',
    desc:"Kerala's secret hill station — coffee and tea estates, Kaikatty Valley and magnificent sunsets over the Palakkad Gap.",
    includes:['Nelliyampathy Peak','Coffee Estate Walk','Seethargundu Viewpoint','Pothundi Dam','Nelliampathy Village','Malampuzha Drive'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Unspoiled coffee hill estate',
    img:'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=600&q=80' },

  /* ══════════════════════════════
     KERALA — BACKWATERS
     ══════════════════════════════ */
  { id:48, state:'Kerala', cat:'Backwaters', dest:'Alappuzha', type:'Houseboat', icon:'🚢', tag:'Popular',
    title:'Alleppey Houseboat Cruise',
    desc:"Float through the Venice of the East — overnight houseboat through Vembanad Lake and rice paddies.",
    includes:['Houseboat Overnight Stay','Vembanad Lake Cruise','Alleppey Beach','Marari Beach','Coir Village','Nehru Trophy Boat Race Site'],
    duration:'2 Days / 1 Night', vehicle:'Transfer provided', highlight:'Overnight in backwater houseboat',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  { id:49, state:'Kerala', cat:'Backwaters', dest:'Kumarakom', type:'Nature', icon:'🦜',
    title:'Kumarakom Bird Sanctuary Tour',
    desc:"Kumarakom Bird Sanctuary on the banks of Vembanad Lake — the perfect Kerala backwater and bird watching combo.",
    includes:['Kumarakom Bird Sanctuary','Vembanad Lake Cruise','Aruvikkuzhi Waterfall','Baker\'s Bungalow','Toddy Tapping Experience','Village Canoe Ride'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'500+ species bird sanctuary',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:50, state:'Kerala', cat:'Backwaters', dest:'Kollam', type:'Backwater', icon:'🌴',
    title:'Kollam Backwater & Beach Tour',
    desc:"Gateway to Kerala backwaters — Ashtamudi Lake houseboat, Cashew Capital and pristine Kollam beach.",
    includes:['Ashtamudi Lake Cruise','Kollam Beach','Cashew Factory Visit','Thangasserry Fort','Jatayu Earth\'s Centre','Palaruvi Falls'],
    duration:'Full Day / Overnight', vehicle:'Any Vehicle', highlight:'Ashtamudi 8-armed lake cruise',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  { id:51, state:'Kerala', cat:'Backwaters', dest:'Kuttanad', type:'Nature', icon:'🌾',
    title:'Kuttanad Below Sea Level Tour',
    desc:"The Rice Bowl of Kerala — paddy fields below sea level, Chinese fishing nets and traditional Kerala village life.",
    includes:['Kuttanad Paddy Fields','Chinese Fishing Nets','Champakulam Church','Thazhathangady Heritage Walk','Backwater Village Canoe','Nehru Trophy Venue'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Farming below sea level — unique!',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  /* ══════════════════════════════
     KERALA — BEACHES
     ══════════════════════════════ */
  { id:52, state:'Kerala', cat:'Beaches & Coastal', dest:'Kovalam', type:'Beach', icon:'🌊',
    title:'Kovalam Beach Paradise Tour',
    desc:"Kerala's most famous beach — three crescent beaches, lighthouse sunset view and Ayurvedic massage.",
    includes:['Lighthouse Beach','Hawa Beach','Samudra Beach','Vizhinjam Mosque','Padmanabhaswamy Temple','Attukal Bhagavathy Temple'],
    duration:'2 Days', vehicle:'4 or 7 Seater', highlight:'Lighthouse sunset views',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  { id:53, state:'Kerala', cat:'Beaches & Coastal', dest:'Varkala', type:'Beach', icon:'🏖️',
    title:'Varkala Cliff Beach Tour',
    desc:"A beach town with a difference — dramatic red cliffs overlooking the Arabian Sea, Janardhana Swami Temple.",
    includes:['Varkala North Beach','Varkala Cliff Walk','Janardhana Swami Temple','Papanasam Beach','Anjengo Fort','Azhimala Shiva Temple'],
    duration:'Full Day / 2 Days', vehicle:'4 or 7 Seater', highlight:'Cliff-top Arabian Sea views',
    img:'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=600&q=80' },

  { id:54, state:'Kerala', cat:'Beaches & Coastal', dest:'Bekal', type:'Heritage', icon:'🏰',
    title:'Bekal Fort & Beach Tour',
    desc:"The largest fort in Kerala on a dramatic rocky headland overlooking the Arabian Sea — Bekal Fort, Kappil Beach.",
    includes:['Bekal Fort','Kappil Beach','Bekal Hole Aqua Tourism','Nityananda Ashram','Chandragiri Fort','Kasaragod Town'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Largest fort in Kerala',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:55, state:'Kerala', cat:'Beaches & Coastal', dest:'Marari Beach', type:'Beach', icon:'🌴',
    title:'Marari Beach Village Tour',
    desc:"A hidden paradise — a quiet fishing village beach perfect for couples and families seeking a peaceful Kerala escape.",
    includes:['Marari Beach','Coir Village Visit','Fisher Village Walk','Alappuzha Day Trip','Backwater Village Canoe','Coconut Farm Tour'],
    duration:'Full Day / 2 Days', vehicle:'4 or 7 Seater', highlight:'Secluded unspoiled beach',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  /* ══════════════════════════════
     KERALA — WILDLIFE / NATURE
     ══════════════════════════════ */
  { id:56, state:'Kerala', cat:'Nature & Wildlife', dest:'Thekkady', type:'Wildlife', icon:'🐘',
    title:'Thekkady Periyar Tiger Reserve',
    desc:"Periyar Lake boat safari — spot wild elephants, sambar deer and rare birds in their natural habitat.",
    includes:['Periyar Lake Boat Safari','Kumily Spice Market','Elephant Junction','Bamboo Rafting','Nature Walk','Cardamom Estate Visit'],
    duration:'Full Day / 2 Days', vehicle:'4 or 7 Seater', highlight:'Lake safari — wild elephant herds',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:57, state:'Kerala', cat:'Nature & Wildlife', dest:'Eravikulam National Park', type:'Wildlife', icon:'🦌',
    title:'Eravikulam Nilgiri Tahr Tour',
    desc:"Home of the endangered Nilgiri Tahr — the only place in the world you can see them up close in the wild.",
    includes:['Eravikulam NP','Nilgiri Tahr Safari','Rajamala Peak','Anamudi Base','Munnar Town','Tea Museum'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Endangered Nilgiri Tahr up close',
    img:'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=600&q=80' },

  { id:58, state:'Kerala', cat:'Nature & Wildlife', dest:'Athirappilly Falls', type:'Nature', icon:'💧',
    title:'Athirappilly Waterfalls Tour',
    desc:"The Niagara of India in Kerala — the largest waterfall in Kerala at 80 ft, surrounded by dense rainforest.",
    includes:['Athirappilly Falls','Vazhachal Falls','Charpa Falls','Thumboormuzhi Dam','Sholayar Dam','Chalakudy River Rafting'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Kerala\'s largest waterfall',
    img:'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=600&q=80' },

  { id:59, state:'Kerala', cat:'Nature & Wildlife', dest:'Silent Valley National Park', type:'Wildlife', icon:'🦁',
    title:'Silent Valley National Park Trek',
    desc:"One of the last undisturbed tropical rainforests in India — Lion-tailed Macaque, rare flora and pristine streams.",
    includes:['Silent Valley Core Zone','Sairandhri Viewpoint','Kunthipuzha River','Lion-tailed Macaque Spotting','Mud Tribes Village','Palakkad Gap View'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Last untouched tropical rainforest',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:60, state:'Kerala', cat:'Nature & Wildlife', dest:'Meesapulimala', type:'Adventure', icon:'⛰️',
    title:'Meesapulimala Trek (2nd Highest)',
    desc:"The 2nd highest peak in Western Ghats — a challenging trek through shola grasslands with stunning 360° views.",
    includes:['Meesapulimala Summit Trek','Rhino Valley','Top Station','Munnar Town','Tea Estate Trail','Camp Fire (Night)'],
    duration:'2 Days / 1 Night', vehicle:'4 or 7 Seater', highlight:'2nd highest peak in Western Ghats',
    img:'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=80' },

  /* ══════════════════════════════
     KERALA — CITIES / CULTURAL
     ══════════════════════════════ */
  { id:61, state:'Kerala', cat:'Cities & Culture', dest:'Kochi', type:'Heritage', icon:'⛵',
    title:'Kochi Fort & Backwater Tour',
    desc:"Queen of the Arabian Sea — Chinese fishing nets, Fort Kochi heritage walk, Mattancherry spice market and Jewish Synagogue.",
    includes:['Fort Kochi Walk','Chinese Fishing Nets','Jewish Synagogue','Mattancherry Palace','Spice Market','Marine Drive'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Chinese fishing nets at sunset',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:62, state:'Kerala', cat:'Cities & Culture', dest:'Thrissur', type:'Cultural', icon:'🥁',
    title:'Thrissur Cultural & Vadakkumnathan Tour',
    desc:"Cultural Capital of Kerala — Vadakkumnathan Temple, famous Thrissur Pooram venue, Athirapally Falls combine.",
    includes:['Vadakkumnathan Temple','Thrissur Pooram Grounds','Kerala Sangeetha Nataka Academy','Shakthan Thampuran Palace','Peechi Dam','Athirappilly Falls'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Cultural capital of Kerala',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  { id:63, state:'Kerala', cat:'Cities & Culture', dest:'Thiruvananthapuram', type:'Cultural', icon:'🏛️',
    title:'Trivandrum Heritage & Kovalam Tour',
    desc:"Kerala's capital — Padmanabhaswamy Temple, Napier Museum, Zoological Garden and Kovalam Beach.",
    includes:['Padmanabhaswamy Temple','Napier Museum','Zoological Garden','Kuthiramalika Palace','Kovalam Beach','Veli Tourist Village'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Padmanabhaswamy — richest temple',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:78, state:'Kerala', cat:'Cities & Culture', dest:'Kozhikode', type:'Heritage', icon:'🍛',
    title:'Kozhikode Calicut Heritage Tour',
    desc:"The City of Spices — where Vasco da Gama landed, famous Kozhikode Halwa, Beypore boat-building yards and Mananchira Square.",
    includes:['Mananchira Square','Kozhikode Beach','Beypore Port & Boat Yard','Sweet Street Halwa Tasting','Kuttichira Heritage Mosque','Pazhassi Raja Museum'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:"Vasco da Gama's landing city",
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  { id:79, state:'Kerala', cat:'Cities & Culture', dest:'Palakkad', type:'Heritage', icon:'🏰',
    title:'Palakkad Fort & Gap Tour',
    desc:"Gateway to Kerala — the magnificent Tipu Sultan Fort, Malampuzha Dam and the famous Palakkad Gap in the Western Ghats.",
    includes:['Palakkad Fort (Tipu Sultan)','Malampuzha Dam & Garden','Palakkad Gap Viewpoint','Silent Valley Entry Point','Parambikulam Dam','Dhoni Waterfalls'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:"Tipu Sultan's 18th century fort",
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  /* ══════════════════════════════
     KERALA — OTHER DESTINATIONS
     ══════════════════════════════ */
  { id:64, state:'Kerala', cat:'Other Destinations', dest:'Guruvayur', type:'Pilgrimage', icon:'🛕',
    title:'Guruvayur Sri Krishna Temple Tour',
    desc:"The Dwarka of the South — Guruvayur Sri Krishna Temple, Punnathur Kotta elephant sanctuary.",
    includes:['Guruvayur Sri Krishna Temple','Punnathur Kotta Elephant Sanctuary','Chavakad Beach','Thiruvambadi Krishna Temple','Mammiyoor Shiva Temple','Thrissur Combine'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'60+ captive elephants sanctuary',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  { id:65, state:'Kerala', cat:'Other Destinations', dest:'Poovar', type:'Nature', icon:'🌅',
    title:'Poovar Island & Estuary Tour',
    desc:"Where river, sea and backwaters meet — golden sand bar island, floating cottages and breathtaking sunsets.",
    includes:['Poovar Golden Sand Bar','Neyyar Dam Boat Safari','Crocodile Farm','Lighthouse Beach','Estuary Boat Ride','Kalaripayattu Show'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'River meets sea — floating resort',
    img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80' },

  { id:66, state:'Kerala', cat:'Other Destinations', dest:'Malampuzha', type:'Nature', icon:'🌿',
    title:'Malampuzha Dam & Fantasy Park',
    desc:"Palakkad\'s gem — Malampuzha Dam garden, ropeway, Fantasy Park and the famous rock garden.",
    includes:['Malampuzha Dam','Rock Garden','Ropeway Ride','Fantasy Park','Yakshi Sculpture','Palakkad Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Fantasy Park ropeway over dam',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:67, state:'Kerala', cat:'Other Destinations', dest:'Thenmala', type:'Eco', icon:'🌳',
    title:'Thenmala Eco Tourism Tour',
    desc:"India's first planned eco-tourism destination — hanging bridge, deer park, sculpture garden and adventure activities.",
    includes:['Hanging Bridge','Deer Rehabilitation Centre','Shenduruney Wildlife Sanctuary','Kallada River Rafting','Butterfly Garden','Sculpture Garden'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'India\'s first eco-tourism site',
    img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80' },

  { id:68, state:'Kerala', cat:'Other Destinations', dest:'Kappad Beach', type:'Heritage', icon:'⚓',
    title:'Kappad Vasco da Gama Beach Tour',
    desc:"Where Vasco da Gama first landed in India in 1498 — historical Kappad Beach, Koyilandy and Kozhikode.",
    includes:['Kappad Beach & Memorial','Kozhikode Beachfront','Mananchira Square','Sweet Street Halwa Shops','Koyilandy Fishing Harbour','Beypore Port'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Where Vasco da Gama landed 1498',
    img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=600&q=80' },

  /* ══════════════════════════════
     SABARIMALA (PILGRIMAGE)
     ══════════════════════════════ */
  { id:69, state:'Kerala', cat:'Pilgrimage', dest:'Sabarimala', type:'Pilgrimage', icon:'🙏', tag:'Pilgrimage Special',
    title:'Sabarimala Ayyappa Pilgrimage',
    desc:"Blessed journey to Lord Ayyappa — comfortable transport to Pamba base camp and back.",
    includes:['Erumeli Church & Mosque Stop','Pamba River Holy Bath','Sabarimala Sannidhanam','Malikappuram Devi Shrine','Neelimala Viewpoint','Return Transfer'],
    duration:'2–3 Days', vehicle:'7 or 12 Seater', highlight:'Season & non-season available',
    img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=600&q=80' },

  /* ══════════════════════════════
     MULTI-DESTINATION COMBO PACKS
     ══════════════════════════════ */
  { id:70, state:'Combo', cat:'Multi-Destination', dest:'TN + Kerala Combo', type:'Grand Tour', icon:'🗺️', tag:'Best Value',
    title:'Ultimate South India Grand Tour',
    desc:"The best of Tamil Nadu + Kerala in one epic multi-day journey — temples, hills, backwaters, beaches and wildlife.",
    includes:['Kodaikanal Hills','Munnar Tea Estates','Alleppey Backwaters','Rameswaram Temple','Kanyakumari Sunrise','Periyar Wildlife'],
    duration:'7–10 Days', vehicle:'Any Vehicle', highlight:'7+ destinations — 1 trip',
    img:'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&q=80' },

  { id:71, state:'Combo', cat:'Multi-Destination', dest:'Temple Circuit', type:'Pilgrimage', icon:'🛕',
    title:'South India Temple Circuit',
    desc:"The grand Dravidian temple tour — Meenakshi Madurai, Ramanathaswamy Rameswaram, Nataraja Chidambaram and more.",
    includes:['Meenakshi Temple Madurai','Ramanathaswamy Rameswaram','Nataraja Temple Chidambaram','Brihadeeswarar Thanjavur','Ranganathaswamy Srirangam','Tirumala Tirupati'],
    duration:'5–7 Days', vehicle:'Any Vehicle', highlight:'6 major Dravidian temples',
    img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&q=80' },

  { id:72, state:'Combo', cat:'Multi-Destination', dest:'Honeymoon Grand', type:'Honeymoon', icon:'💑',
    title:'Kerala + Kodaikanal Honeymoon',
    desc:"The ultimate South India honeymoon — misty Munnar hills, Alleppey houseboat, Varkala cliff beach and Kodaikanal sunsets.",
    includes:['Kodaikanal 2 Days','Munnar Tea Estate Stay','Alleppey Houseboat Night','Varkala Cliff Beach','Kovalam Sunset','Kanyakumari Sunrise'],
    duration:'8–10 Days', vehicle:'4-Seater Car', highlight:'The perfect South India honeymoon',
    img:'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=600&q=80' },

  /* ══════════════════════════════
     STATION PICKUP / TRANSFERS
     ══════════════════════════════ */
  { id:73, state:'Transfer', cat:'Pickup & Drop', dest:'Kodai Road', type:'Transfer', icon:'🚉',
    title:'Kodai Road Station Pickup',
    desc:"Arriving by train? We'll pick you up from Kodai Road Railway Station and take you comfortably to any destination.",
    includes:['Station Pickup on Time','Door-to-Door Drop','AC Vehicle','Luggage Help','Any Arrival Time','No Hidden Charges'],
    duration:'1.5–2 hrs to Kodaikanal', vehicle:'Any Vehicle', highlight:'24/7 — any train timing',
    img:'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=600&q=80' },

  { id:74, state:'Transfer', cat:'Pickup & Drop', dest:'Madurai Airport', type:'Transfer', icon:'✈️',
    title:'Madurai Airport Transfer',
    desc:"Comfortable AC cab from Madurai Airport to Kodaikanal, Rameswaram or any destination.",
    includes:['Flight Tracking','Airport Meet & Greet','AC Vehicle','Hotel Drop','Luggage Assistance','Any Time'],
    duration:'2.5–3 hrs', vehicle:'Any Vehicle', highlight:'Flight tracking — never late',
    img:'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&q=80' },
];

/* ──────────────────────────────────────
   FILTER CONFIGURATION
   ────────────────────────────────────── */
const STATES = ['All States', 'Tamil Nadu', 'Kerala', 'Combo', 'Transfer'];

const TN_CATS  = ['Hill Stations','Temple & Spiritual','Heritage & Culture','Beaches & Coastal','Nature & Wildlife','Other Destinations'];
const KL_CATS  = ['Hill Stations','Backwaters','Beaches & Coastal','Nature & Wildlife','Cities & Culture','Pilgrimage','Other Destinations'];
const COMBOS   = ['Multi-Destination','Pickup & Drop'];
const TOUR_TYPES = ['All Types','Honeymoon','Family','Group','Pilgrimage','Sightseeing','Nature','Heritage','Wildlife','Adventure','Beach','Houseboat','Transfer','Grand Tour'];

const DEST_BY_STATE = {
  'Tamil Nadu': [
    // Hill Stations
    'Kodaikanal','Ooty','Coonoor','Yercaud','Kotagiri','Valparai','Yelagiri','Kolli Hills',
    // Temple & Spiritual
    'Madurai','Rameswaram','Chidambaram','Kanchipuram','Tiruchirappalli','Palani','Tiruvannamalai','Srirangam',
    // Heritage
    'Thanjavur','Chettinad','Mahabalipuram','Gangaikonda Cholapuram','Darasuram',
    // Beaches & Coastal
    'Kanyakumari','Chennai','Velankanni','Nagapattinam','Poompuhar','Thoothukudi',
    // Nature & Wildlife
    'Mudumalai National Park','Anamalai Tiger Reserve','Hogenakkal Falls','Courtallam',
    // Other Destinations
    'Dhanushkodi','Salem','Erode','Coimbatore','Tirunelveli','Kumbakonam','Ramanathapuram','Srivilliputhur','Sivakasi',
  ],
  'Kerala': [
    // Hill Stations
    'Munnar','Wayanad','Vagamon','Ponmudi','Idukki','Nelliyampathy',
    // Backwaters
    'Alappuzha','Kumarakom','Kollam','Kuttanad',
    // Beaches
    'Kovalam','Varkala','Marari Beach','Bekal',
    // Nature & Wildlife
    'Thekkady','Eravikulam National Park','Athirappilly Falls','Silent Valley National Park','Meesapulimala',
    // Cities & Culture
    'Kochi','Thrissur','Kozhikode','Thiruvananthapuram','Palakkad',
    // Others
    'Sabarimala','Guruvayur','Poovar','Malampuzha','Kappad Beach','Thenmala',
  ],
};

const IMG_MAP = {
  'Tamil Nadu': 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&q=80',
  'Kerala':     'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=400&q=80',
};

export default function Tours() {
  const [stateFilter, setStateFilter] = useState('All States');
  const [catFilter,   setCatFilter]   = useState('');
  const [typeFilter,  setTypeFilter]  = useState('All Types');
  const [destFilter,  setDestFilter]  = useState('');
  const [search,      setSearch]      = useState('');
  const [expanded,    setExpanded]    = useState(null);
  const [view,        setView]        = useState('grid'); // 'grid' | 'list'

  // Dynamic categories based on state
  const activeCats = useMemo(() => {
    if (stateFilter === 'Tamil Nadu') return TN_CATS;
    if (stateFilter === 'Kerala')     return KL_CATS;
    if (stateFilter === 'Combo' || stateFilter === 'Transfer') return COMBOS;
    return [...new Set([...TN_CATS, ...KL_CATS, ...COMBOS])];
  }, [stateFilter]);

  // Filtered packages (full - used for count)
  const filtered = useMemo(() => ALL_PACKAGES.filter(p => {
    if (stateFilter !== 'All States' && p.state !== stateFilter) return false;
    if (catFilter   && p.cat  !== catFilter)   return false;
    if (typeFilter  !== 'All Types' && p.type !== typeFilter) return false;
    if (destFilter  && p.dest !== destFilter)  return false;
    if (search) {
      const q = search.toLowerCase();
      return p.title.toLowerCase().includes(q) ||
             p.dest.toLowerCase().includes(q)  ||
             p.desc.toLowerCase().includes(q)  ||
             p.cat.toLowerCase().includes(q);
    }
    return true;
  }), [stateFilter, catFilter, typeFilter, destFilter, search]);

  // Packages matching only State + Category (for Type and Destination options)
  const catMatched = useMemo(() => ALL_PACKAGES.filter(p => {
    if (stateFilter !== 'All States' && p.state !== stateFilter) return false;
    if (catFilter && p.cat !== catFilter) return false;
    return true;
  }), [stateFilter, catFilter]);

  // Available types for current state+category combo
  const availableTypes = useMemo(() => {
    const types = [...new Set(catMatched.map(p => p.type))];
    return TOUR_TYPES.filter(t => t === 'All Types' || types.includes(t));
  }, [catMatched]);

  // Available destinations for current state+category combo
  const availableDests = useMemo(() => {
    const dests = new Set(catMatched.map(p => p.dest));
    if (stateFilter === 'Tamil Nadu') return DEST_BY_STATE['Tamil Nadu'].filter(d => dests.has(d));
    if (stateFilter === 'Kerala')     return DEST_BY_STATE['Kerala'].filter(d => dests.has(d));
    if (stateFilter === 'Combo')      return ['TN + Kerala Combo','Temple Circuit','Honeymoon Grand'].filter(d => dests.has(d));
    if (stateFilter === 'Transfer')   return ['Kodai Road','Madurai Airport'].filter(d => dests.has(d));
    return [...DEST_BY_STATE['Tamil Nadu'], ...DEST_BY_STATE['Kerala']].filter(d => dests.has(d));
  }, [catMatched, stateFilter]);

  // Show Type row only if there are 2+ type options (excluding All Types)
  const showTypeFilter = availableTypes.length > 2;
  // Show Destination row only if there are 2+ destination options
  const showDestFilter = availableDests.length > 1;

  // Auto-clear invalid selections when category changes
  const handleCatChange = (cat) => {
    setCatFilter(cat);
    setTypeFilter('All Types');
    setDestFilter('');
  };

  const resetFilters = () => {
    setStateFilter('All States'); setCatFilter('');
    setTypeFilter('All Types');   setDestFilter(''); setSearch('');
  };

  const hasFilter = stateFilter !== 'All States' || catFilter || typeFilter !== 'All Types' || destFilter || search;

  return (
    <div className="tours-page page-enter">

      {/* ── HERO ── */}
      <div className="tours-hero">
        <div className="tours-hero__bg" />
        <div className="tours-hero__overlay" />
        <div className="container tours-hero__content">
          <p className="eyebrow">Maggi Cabs — Since 2003</p>
          <h1 className="display-title light">All Tour Packages</h1>
          <div className="amber-line" />
          <p>79 packages across 75 destinations in Tamil Nadu & Kerala. Call +91 9445879508 anytime.</p>
          <div className="tours-hero-stats">
            <span>🗺️ 75 Destinations</span>
            <span>📦 79 Packages</span>
            <span>🚗 4 Vehicle Types</span>
            <span>📞 24/7 Booking</span>
          </div>
        </div>
      </div>

      {/* ── STATE SELECTOR ── */}
      <div className="state-bar">
        <div className="container state-bar__inner">
          {STATES.map(s => (
            <button key={s}
              className={`state-btn ${stateFilter === s ? 'active' : ''}`}
              onClick={() => { setStateFilter(s); setCatFilter(''); setTypeFilter('All Types'); setDestFilter(''); }}>
              {s === 'Tamil Nadu' ? '🏛️ Tamil Nadu' :
               s === 'Kerala'    ? '🌿 Kerala'     :
               s === 'Combo'     ? '🗺️ Combos'     :
               s === 'Transfer'  ? '🚉 Transfers'  : '🌏 All States'}
            </button>
          ))}
        </div>
      </div>

      {/* ── MAIN CONTENT ── */}
      <section className="section-pad">
        <div className="container">

          {/* ── FILTER PANEL ── */}
          <div className="filter-panel">

            {/* Search */}
            <div className="tours-search">
              <svg width="16" height="16" fill="none" stroke="#aaa" strokeWidth="2" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <input type="text" placeholder="Search destinations, tour types..."
                value={search} onChange={e => setSearch(e.target.value)} />
              {search && <button className="search-clear" onClick={() => setSearch('')}>✕</button>}
            </div>

            {/* Category — always shown */}
            {activeCats.length > 0 && (
              <div className="filter-row">
                <span className="filter-label">Category:</span>
                <div className="filter-chips">
                  <button className={`chip ${!catFilter ? 'active' : ''}`}
                    onClick={() => handleCatChange('')}>All</button>
                  {activeCats.map(c => (
                    <button key={c} className={`chip ${catFilter === c ? 'active' : ''}`}
                      onClick={() => handleCatChange(c)}>{c}</button>
                  ))}
                </div>
              </div>
            )}

            {/* Type — only shown if 2+ types exist for current category */}
            {showTypeFilter && (
              <div className="filter-row filter-row--animated">
                <span className="filter-label">Type:</span>
                <div className="filter-chips">
                  {availableTypes.map(t => (
                    <button key={t} className={`chip ${typeFilter === t ? 'active' : ''}`}
                      onClick={() => { setTypeFilter(t); setDestFilter(''); }}>{t}</button>
                  ))}
                </div>
              </div>
            )}

            {/* Destination — only shown if 2+ destinations exist for current category */}
            {showDestFilter && (
              <div className="filter-row filter-row--dest filter-row--animated">
                <span className="filter-label">Destination:</span>
                <div className="filter-chips">
                  <button className={`chip ${!destFilter ? 'active' : ''}`}
                    onClick={() => setDestFilter('')}>All</button>
                  {availableDests.map(d => (
                    <button key={d} className={`chip ${destFilter === d ? 'active' : ''}`}
                      onClick={() => setDestFilter(d)}>{d}</button>
                  ))}
                </div>
              </div>
            )}

          </div>

          {/* Results bar */}
          <div className="results-bar">
            <div className="results-info">
              Showing <strong>{filtered.length}</strong> of {ALL_PACKAGES.length} packages
              {catFilter && <span className="results-tag">{catFilter}</span>}
              {destFilter && <span className="results-tag">{destFilter}</span>}
              {typeFilter !== 'All Types' && <span className="results-tag">{typeFilter}</span>}
            </div>
            <div className="results-actions">
              {hasFilter && (
                <button className="clear-all-btn" onClick={resetFilters}>✕ Clear All</button>
              )}
              <div className="view-toggle">
                <button className={view === 'grid' ? 'active' : ''} onClick={() => setView('grid')}>
                  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M3 3h7v7H3V3zm11 0h7v7h-7V3zM3 14h7v7H3v-7zm11 0h7v7h-7v-7z"/></svg>
                </button>
                <button className={view === 'list' ? 'active' : ''} onClick={() => setView('list')}>
                  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"/></svg>
                </button>
              </div>
            </div>
          </div>

          {/* ── PACKAGES ── */}
          {filtered.length === 0 ? (
            <div className="tours-empty">
              <span>🔍</span>
              <h3>No packages found</h3>
              <p>Try different filters or search terms</p>
              <button className="btn-green" onClick={resetFilters}>View All Packages</button>
            </div>
          ) : (
            <div className={`pkg-grid ${view === 'list' ? 'pkg-grid--list' : ''}`}>
              {filtered.map(pkg => (
                <div key={pkg.id} className={`pkg-card card ${view === 'list' ? 'pkg-card--list' : ''}`}>

                  <div className="pkg-card__img">
                    <img src={pkg.img} alt={pkg.title} loading="lazy" />
                    <div className="pkg-img-overlay" />
                    <div className="pkg-img-badges">
                      <span className="pkg-state-badge">{pkg.state}</span>
                      <span className="pkg-region-badge">{pkg.cat}</span>
                    </div>
                    {pkg.tag && <span className="pkg-tag">{pkg.tag}</span>}
                  </div>

                  <div className="pkg-card__body">
                    <div className="pkg-card__head">
                      <span className="pkg-icon">{pkg.icon}</span>
                      <div>
                        <span className="pkg-dest-label">📍 {pkg.dest}</span>
                        <h3 className="pkg-title">{pkg.title}</h3>
                      </div>
                    </div>

                    <p className="pkg-desc">{pkg.desc}</p>

                    {/* Expandable highlights */}
                    <div className="pkg-includes">
                      <button className="pkg-includes__btn"
                        onClick={() => setExpanded(expanded === pkg.id ? null : pkg.id)}>
                        <span>✓ {pkg.includes.length} Highlights</span>
                        <span className="pkg-arrow">{expanded === pkg.id ? '▲' : '▼'}</span>
                      </button>
                      {expanded === pkg.id && (
                        <div className="pkg-tags-wrap">
                          {pkg.includes.map(item => (
                            <span key={item} className="pkg-tag-item">✓ {item}</span>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="pkg-meta">
                      <span>⏱ {pkg.duration}</span>
                      <span>🚗 {pkg.vehicle}</span>
                      <span className="pkg-highlight-badge">★ {pkg.highlight}</span>
                    </div>

                    <div className="pkg-actions">
                      <a href={`https://wa.me/${WA}?text=Hi%20Anbu%20Kumar!%20I%27m%20interested%20in%20${encodeURIComponent(pkg.title)}`}
                        target="_blank" rel="noreferrer" className="btn-primary">💬 Book Now</a>
                      <a href="tel:+919445879508" className="btn-green">📞 Call</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Custom CTA */}
      <div className="tours-cta container">
        <div className="tours-cta__inner">
          <div>
            <h3>🗺️ Need a Custom Multi-Day Tour?</h3>
            <p>Mix any Tamil Nadu + Kerala destinations — we plan the perfect itinerary for your group & budget!</p>
          </div>
          <a href={`https://wa.me/${WA}?text=Hi!%20I%20need%20a%20custom%20multi-destination%20tour%20package.`}
            target="_blank" rel="noreferrer" className="btn-primary">💬 WhatsApp for Custom Tour</a>
        </div>
      </div>
    </div>
  );
}
